import React, { Component } from 'react';
import { Tabs, Tab, Button, Form} from 'react-bootstrap';
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  ReactFlowProvider,
  Node,
  Edge,
  Position,
  MarkerType,
} from 'react-flow-renderer';
import Switch from 'react-switch';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

import AddFieldModal from './AddFieldModal';
import  DataModelTreeNode from './DataModelTreeNode';

import { MAX_DATA_DENCITY_THRESOLD_PCT, NULL_DENCITY_THRESOLD_PCT, isFieldUnused, getFieldDataType, getFieldGrpNmConverted, getFieldNmConverted, convertToRawDm, cleanDm} from './constants';

interface DMERDiagramProps { 
  data: any | null; 
  selectedDMPrimaryTable: string | null;
  selectedFields: Record<string, Set<string>>;
  entity: any | null;
  actionDMERDiagram: string;
  handleUpdateMDMConfig: (topTableName: string, config: any, beImported: boolean) => void;
  handleUploadMDMConfig: (dataStr:string) => void;
}

interface DMERDiagramState {
  elements: (Node | Edge)[];
  allElements: (Node | Edge)[];
  parentOptions: string[];
  showLookupTables: boolean;
  lookupTables: Set<string>;
  selectedFields: Record<string, Set<string>>;
  filteredElement: string;
  tableColumnMap: Record<string, any[]>;
  fkMap: Record<string, string[]>;
  fkTableMap: Record<string, string[]>;
  lkpMap: Record<string, string[]>;
  fkInfoMap: any | null,
  showUnusedTables: boolean;
  showUnusedColumns: boolean;
  showEnityModal: boolean;
  entityBuildType: string,
  entityImportEntityNm: string,
  
}

class DMERDiagram extends Component<DMERDiagramProps, DMERDiagramState> {
  constructor(props: DMERDiagramProps) {
    super(props);
    this.state = {
      elements: [],
      allElements: [],
      parentOptions: [],
      showLookupTables: false,
      lookupTables: new Set(),
      selectedFields: {},
      filteredElement: '',
      tableColumnMap: {},
      fkMap: {},
      lkpMap: {},
      fkTableMap: {},
      fkInfoMap: {},
      showUnusedTables: false,
      showUnusedColumns: false,
      showEnityModal: false,
      entityBuildType: 'entityImport',
      entityImportEntityNm: '',
    };
  }

  componentDidMount() {
    if (this.props.data) this.initializeFromData(this.props.data);
  }

  componentDidUpdate(prevProps: DMERDiagramProps) {
    if (this.props.data && prevProps.data !== this.props.data) {
      this.initializeFromData(this.props.data);
      this.setState({selectedFields: this.props.selectedFields, filteredElement:this.props.selectedDMPrimaryTable||''});
    }
    if ((this.props.selectedDMPrimaryTable && this.props.selectedDMPrimaryTable !== this.state.filteredElement)){
      this.setState({selectedFields: this.props.selectedFields, filteredElement:this.props.selectedDMPrimaryTable||''}, () => this.initializeFromData(this.props.data));
      
      
    }
    //
    
    //if (this.props.selectedFields !== prevProps.selectedFields && this.props.selectedFields && Object.keys(this.props.selectedFields).length > 0){
    //  this.setState({selectedFields: this.props.selectedFields})
    //}
  }

  initializeFromData = (data: any) => {
    const lookupTables: Set<string> = new Set(
      data.addBaseObject.filter((t: any) => {
        return (t.lookupIndicator === 'true')
      }).map((t: any) => t.tableName)
    );
    lookupTables.add('C_RBO_BO_CLASS');
    lookupTables.add('C_RBO_REL_TYPE');
    lookupTables.add('C_RBO_HIERARCHY');

    const allElements = this.buildElements(data, this.state.showLookupTables, this.state.showUnusedTables, this.state.showUnusedColumns, lookupTables);
    const parentOptions = this.getParentTables(data, lookupTables);
    this.setState({ allElements, parentOptions, lookupTables }, () => this.setFilteredElements(this.state.filteredElement));
  };

  getParentTables = (data: any, lookupTables: Set<string>): string[] => {
    const allTables = data.addBaseObject.filter((t: any) => t.lookupIndicator === 'false').map((t: any) => t.tableName).sort();
    return allTables;
    /*const childTables = new Set(
      data.addForeignKey
        .filter((fk: any) => !lookupTables.has(fk['@id'].split('.')[2].split('(')[0]))
        .map((fk: any) => fk['@id'].split('.')[1].split('(')[0])
    );
    return allTables.filter((t: string) => !childTables.has(t));*/
  };

  buildElements = (data: any, includeLookup: boolean, showUnusedTables: boolean, showUnusedColumns: boolean,  lookupTables: Set<string>): (Node | Edge)[] => {
    const nodes: Node[] = [];
    const edges: Edge[] = [];
    const tableColumnMap: Record<string, any[]> = {};

    data.addBaseObjectColumn.forEach((col: any) => {
      const tableName = col['@id'].split('|')[0].split('.')[1];
      if (!tableColumnMap[tableName]) tableColumnMap[tableName] = [];
      tableColumnMap[tableName].push(col);
    });

    const fkTableMap: Record<string, string[]> = {};
    const fkMap: Record<string, string[]> = {};
    const lkpMap: Record<string, string[]> = {};
    const fkInfoMap = {};
    data.addForeignKey.forEach((fk: any) => {
      const [sourceTablePart, targetTablePart] = fk['@id'].split(').');
      const sourceTable = sourceTablePart.split('(')[0].split('.')[1];
      const sourceColumn = sourceTablePart.split('(')[1];
      const targetTable = targetTablePart.split('(')[0];
      const targetColumn = targetTablePart.split('(')[1].replace(')','');

      if (!fkTableMap[sourceTable]) fkTableMap[sourceTable] = [];
      if (!lookupTables.has(targetTable))
        fkTableMap[sourceTable].push(targetTable);
      
      if (!fkMap[sourceTable]) fkMap[sourceTable] = [];
      fkMap[sourceTable].push(sourceColumn);
      
      if (!lkpMap[sourceTable]) lkpMap[sourceTable] = [];
      if (lookupTables.has(targetTable))
        lkpMap[sourceTable].push(sourceColumn);
      
      if (!(fkInfoMap as any)[sourceTable]) (fkInfoMap as any)[sourceTable] = [];
      (fkInfoMap as any)[sourceTable].push({
        column: sourceColumn,
        referencedTable: targetTable,
        referencedColumn: targetColumn,
      });

      edges.push({
        id: fk['@id'],
        source: sourceTable,
        target: targetTable,
        //label: `${sourceColumn} → ROWID_OBJECT`,
        //animated: true,
        //style: { stroke: '#888' },
        markerEnd: { type: MarkerType.ArrowClosed },
      });
    });

    data.addBaseObject.forEach((table: any) => {
      if (lookupTables.has(table.tableName) && !includeLookup) return;
      if (!showUnusedTables && (table.tableData||0) === 0) return;
      const label = this.getNodeLabel(table, showUnusedColumns);
      
      nodes.push({
        id: table.tableName,
        data: { label },
        position: { x: 0, y: 0 },
        style: {
          border: '1px solid #555',
          borderRadius: 5,
          padding: 10,
          background: '#f5f5f5',
          minWidth: 300,
          whiteSpace: 'pre-wrap',
        },
        sourcePosition: Position.Left,
        targetPosition: Position.Right,
      });
    });

    this.setState({tableColumnMap, fkMap, lkpMap, fkTableMap, fkInfoMap});
    return [...nodes, ...edges];
  };

  getNodeLabel = (table: any, showUnusedColumns: boolean)=> {
    const columns = this.state.tableColumnMap[table.tableName] || [];
    //const clsCss = this.state.selectedFields[table.tableName]?.has('*') ? {border: '1px solid red', textAlign: 'left', fontSize: 12}: {border: '1px solid #555', textAlign: 'left', fontSize: 12};
    const tblCss = table.tableData && table.tableData > 0 ? {color: 'black', paddingLeft: '6px', paddingBottom: '3px'} : {color: 'gray', paddingLeft: '6px', paddingBottom: '3px'};
    const label = (
      <div style={{ textAlign: 'left', fontSize: 12 }}>
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderBottom: '1px solid lightgray',
              padding: '4px 0',
            }}
          >
            <input
              type="checkbox"
              checked={this.state.selectedFields[table.tableName]?.size>0 || false}
              onChange={(e) => this.toggleTableSelection(table.tableName, e.target.checked)}
              style={{ margin: 0 }}
            />
            <div style={tblCss}>
              <strong>{table.displayName}</strong>
            </div>
          </div>

        </div>
        <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0, fontSize: 10, paddingTop: '6px' }}>
          {columns.map((col: any, idx: number) => {
            const isPK = col.columnName === 'ROWID_OBJECT';
            const isFK = (this.state.fkMap[table.tableName] || []).includes(col.columnName);
            const isLKP = (this.state.lkpMap[table.tableName] || []).includes(col.columnName);
            const tag = isPK ? '[PK]' : isLKP ? '[LKP]' : isFK ? '[FK]' : '';
            const isChecked = this.state.selectedFields[table.tableName]?.has(col.columnName) || false;
            
            /*const totalRows = table.tableData||0;
            const nullCount = col.columnData && Array.isArray(col.columnData) 
                ? col.columnData
                    .filter((entry: { DATA: any, CNT: number }) => entry.DATA === null)
                    .reduce((sum: number, entry: { DATA: any, CNT: number }) => sum + entry.CNT, 0)
                : 0;

            const isMostlyNull = totalRows === 0 || (nullCount / totalRows) >= NULL_DENCITY_THRESOLD_PCT;*/
            const isMostlyNull = isFieldUnused(col);
            if (!showUnusedColumns && isMostlyNull) return;

            const colCss = isMostlyNull ? {color: 'gray',  fontFamily: 'monospace' } :  {color: 'black',  fontFamily: 'monospace' };
            return (
              <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => this.toggleFieldSelection(table.tableName, col.columnName, e.target.checked)}
                  style={{ margin: 0 }}
                  disabled ={!isLKP && isFK}
                />
                
                <span style={colCss}>{tag.padEnd(5)} {col.displayName}</span>
              </li>

            );
          })}
        </ul>
      </div>
    );
    return label;

  }
  
  toggleTableSelection = (table: string, checked: boolean) => {
    this.setState((prevState) => {
      const updated = { ...prevState.selectedFields };
      if (!updated[table]) updated[table] = new Set();
      if (checked){
        const columns = this.state.tableColumnMap[table] || [];
        const usableCols = columns.forEach((c:any)=>{
          const isFK = (this.state.fkMap[table] || []).includes(c.columnName);
          const isLKP = (this.state.lkpMap[table] || []).includes(c.columnName);
          if (!isFieldUnused(c) && !(isFK && !isLKP)){
            updated[table].add(c.columnName);
          }
        })
        
      } //updated[table].add('*');
      else updated[table].clear();
      return { selectedFields: updated };
    }, () => this.setFilteredElements(this.state.filteredElement));
  };

  toggleFieldSelection = (table: string, column: string, checked: boolean) => {
    this.setState((prevState) => {
      const updated = { ...prevState.selectedFields };
      if (!updated[table]) updated[table] = new Set();
      if (checked) updated[table].add(column);
      else updated[table].delete(column);
      return { selectedFields: updated };
    }, () => this.setFilteredElements(this.state.filteredElement));
  };

  handleZoom = (factor: number) => {
    const event = new CustomEvent('zoom-change', { detail: factor });
    window.dispatchEvent(event);
  };

  recursivelyFindRelated = (startId: string): Set<string> => {
    const visited = new Set<string>();
    const backwardIncluded = new Set<string>();

    //getting parent .. it could be trans or lookup table
    const forwardTraverse = (id: string) => {
      if (visited.has(id)) return;
      visited.add(id);
      const downstream = this.state.allElements.filter(
        (el): el is Edge => 'source' in el && el.source === id
      );
      downstream.forEach(edge => forwardTraverse(edge.target));
    };

    //getting childs.. 
    const backwardTraverse = (id: string) => {
      const upstream = this.state.allElements.filter(
        (el): el is Edge => 'target' in el && el.target === id
      );
      upstream.forEach(edge => {
  
        const srcTyp = this.state.lookupTables.has(id);
        const tgtTyp = this.state.lookupTables.has(edge.source);
        if (!(srcTyp && !tgtTyp)){
          backwardIncluded.add(edge.source);
        }
      });
    };

    forwardTraverse(startId);
    visited.forEach(id => backwardTraverse(id));
    backwardIncluded.forEach(id => forwardTraverse(id));

    return visited;
  };

  setFilteredElements = (parentId?: string) => {
    if (!parentId && this.state.parentOptions.length > 0) parentId = this.state.parentOptions[0];
    if (!parentId) return;
    const visited = this.recursivelyFindRelated(parentId);
    const nodes: Node[] = [];
    const edges: Edge[] = [];
    //const columnsPerRow = 10;
    //let rowHeights: number[] = new Array(columnsPerRow).fill(0);

    this.state.allElements.forEach((el) => {
      if ('id' in el && visited.has(el.id) && 'data' in el) {
        const nSelected = this.state.selectedFields[el.id]?.size>0 ;
        
        //const estimatedHeight = ((el.data.label?.props?.children?.[1]?.props?.children?.length || 1) + 2) * 20 + 60;
        //const col = nodes.length % columnsPerRow;
        //const y = rowHeights[col];
        //const x = col * 350;
        
        const table = this.props.data.addBaseObject.filter((t:any)=>{return t.tableName === el.id})[0];
        const label = this.getNodeLabel(table, this.state.showUnusedColumns)
        const borderCss = table.tableData && table.tableData > 0 ? '1px solid #555' : '1px solid #dddbda';
        nodes.push({ ...(el as Node), data: { label }, style: { ...el.style, border: (nSelected?'2px solid brown':borderCss) } });
        //rowHeights[col] += estimatedHeight + 40;
      } else if ('source' in el && visited.has(el.source)) {
        edges.push(el as Edge);
      }
    });

    const elements = [...nodes, ...edges];
    this.rePositionElements(elements)

    this.setState({filteredElement: parentId });
  };

  rePositionElements = (elements: (Node | Edge)[]) => {
    
    const nodes: Node[] = [];
    const edges: Edge[] = [];
    const columnsPerRow = 10;
    let rowHeights: number[] = new Array(columnsPerRow).fill(0);

    elements.forEach((el) => {
      if ('id' in el && 'data' in el) {
        //const estimatedHeight = ((el.data.label?.props?.children?.[1]?.props?.children?.length || 1) + 2) * 20 + 60;
        const labelChildren = el.data.label?.props?.children?.[1]?.props?.children || [];
        const liCount = Array.isArray(labelChildren)
          ? labelChildren.filter((child: any) => child?.type === 'li').length
          : 1;
        const estimatedHeight = (liCount + 2) * 20 + 60;
        const col = nodes.length % columnsPerRow;
        const y = rowHeights[col];
        const x = col * 350;
        nodes.push({ ...(el as Node), position: { x, y } });
        rowHeights[col] += estimatedHeight + 40;
      } else if ('source' in el) {
        edges.push(el as Edge);
      }
    });

    this.setState({ elements: [...nodes, ...edges] });
  };

  toggleLookupTables = () => {
    const updated = this.buildElements(this.props.data, !this.state.showLookupTables, this.state.showUnusedTables, this.state.showUnusedColumns, this.state.lookupTables);
    this.setState({ allElements: updated, showLookupTables: !this.state.showLookupTables }, () => this.setFilteredElements(this.state.filteredElement));
  };

  toggleUnusedTables = () => {
    const updated = this.buildElements(this.props.data, this.state.showLookupTables, !this.state.showUnusedTables, this.state.showUnusedColumns, this.state.lookupTables);
    this.setState({ allElements: updated, showUnusedTables: !this.state.showUnusedTables }, () => this.setFilteredElements(this.state.filteredElement));
  };

  toggleUnusedColumns = () => {
    const updated = this.buildElements(this.props.data, this.state.showLookupTables, this.state.showUnusedTables, !this.state.showUnusedColumns, this.state.lookupTables);
    this.setState({ allElements: updated, showUnusedColumns: !this.state.showUnusedColumns }, () => this.setFilteredElements(this.state.filteredElement));
  };

  /*
  buildSelectedDataModel = () =>{
    const selectedFields= this.state.selectedFields;
    const newDM = [];
    const selectedTableNames = new Set(Object.keys(this.state.selectedFields));
    
    for (const [tableName, columnNames] of Object.entries(selectedFields)) {
      console.log(`Table: ${tableName}`);
      const table = this.props.data.addBaseObject.filter((t: any) => t.tableName === tableName)[0];
      const fkTables = this.state.fkTableMap[tableName] || [];
      const pTables = fkTables.filter((t: string) => selectedTableNames.has(t)); 
      if (pTables.length > 1){
        alert('two parents found. what you wnat to do?');
      }
      let seq = 0;
      for (const columnName of columnNames) {
        console.log(`  Column: ${columnName}`);
        seq += 1;
        const col = this.state.tableColumnMap[tableName].filter((c: any)=> c.columnName === columnName)[0];
        const fld = {
            TBL_ID: tableName,
            FLD_ID: tableName + "-" + columnName,
            TABLE_NM: table.tableName,
            TABLE_DISPLAY_NM: table.displayName,
            PARENT_TABLE_NM: pTables.length > 0 ? pTables[0]: null,
            COLUMN_NAME: columnName,
            COLUMN_DISPLAY_NAME: col.displayName,
            SEQ: seq,
            DATA_TYP: getFieldDataType(col).DATA_TYP,
            DATA_DEFAULT: null,
            MANDATORY: col.isNullable === "1"?"N":"Y",
            DATA_LEN: getFieldDataType(col).DATA_LEN,
            LOOKUP_RDS_NM: col.lookupRDSNm,
            LOOKUP_RDS_DISP_NM: col.lookupRDSDispNm,
            LOOKUP_RDS_CV: col.lookupRDSCV,
            TABLE_DATA: col.tableData,
            COLUMN_DATA: col.columnData,
            SYSTEM_ORDER: "",
            eClass: "Field",
            SYSTEM_ORDER_GUID: "",
            SYSTEM_ORDER_CD: ""
        };
        newDM.push(fld);
      }
      
    }
    this.props.handleUpdateMDMConfig(newDM);
  }
  */

  buildSelectedDataModel = (entity: any|null) => {
    const selectedFields = this.state.selectedFields;
    const selectedTableNames = new Set(Object.keys(selectedFields));
    const pendingTables = Object.entries(selectedFields);
    const newDM: any[] = [];
    const filteredRoot = this.state.filteredElement;
    const visited = new Set<number>();

    const mapToEntity = (nm: string) =>{
      if (nm === this.state.filteredElement){
        return entity;
      }
      return null;
    }
    const processTable = (tableName: string, columnNames: Set<string>, parentTable: string | null, overrideTableName: string | null) => {
      const table = this.props.data.addBaseObject.find((t: any) => t.tableName === tableName);
      const pTable = parentTable?this.props.data.addBaseObject.find((t: any) => t.tableName === parentTable):null;
      const overrideTable = overrideTableName ? this.props.data.addBaseObject.find((t: any) => t.tableName === overrideTableName) : null;
      let seq = 0;
      let tblNm = overrideTable ? overrideTable.tableName : table.tableName;
      const tblDispNm = overrideTable ? overrideTable.displayName : table.displayName;
      const entity = mapToEntity(tblNm);
      const pEntity = parentTable ? mapToEntity(parentTable) : null;
      const tblId = entity ? entity.name : tblNm;
      
      for (const columnName of columnNames) {
        seq += 1;
        const col = this.state.tableColumnMap[tableName].find((c: any) => c.columnName === columnName);
        const fld = {
          TBL_ID: tblId,
          FLD_ID: `${tblId}-${columnName}`,
          FLD_PHYSICAL_ID: `${table.tableName}-${columnName}`,
          TABLE_NM: entity ? entity.name : getFieldGrpNmConverted(tblDispNm),
          TABLE_DISPLAY_NM: entity ? entity.label : tblDispNm.replace(/[^a-zA-Z\s]/g, " ").trim(),
          
          PARENT_TABLE_NM: pTable && pEntity ? pEntity.name : pTable ? getFieldGrpNmConverted(pTable.displayName) : null,
          COLUMN_NAME: getFieldNmConverted(col.displayName),
          COLUMN_DISPLAY_NAME: col.displayName.trim(),
          SEQ: seq,
          DATA_TYP: getFieldDataType(col).DATA_TYP,
          DATA_DEFAULT: col.dataDefault,
          MANDATORY: col.isNullable === "1" ? "N" : "Y",
          DATA_LEN: getFieldDataType(col).DATA_LEN,
          LOOKUP_RDS_NM: getFieldGrpNmConverted(col.lookupRDSDispNm),
          LOOKUP_RDS_DISP_NM: col.lookupRDSDispNm?col.lookupRDSDispNm.replace(/[^a-zA-Z\s]/g, " ").trim():col.lookupRDSDispNm,
          LOOKUP_RDS_CV: col.lookupRDSCV,
          TABLE_DATA: col.tableData,
          COLUMN_DATA: col.columnData,
          SYSTEM_ORDER: col.systemOrder,
          eClass: "Field",
          SYSTEM_ORDER_GUID: "",
          SYSTEM_ORDER_CD: ""
        };
        newDM.push(fld);
      }
    };

    const handleMultipleParentPrompt = (pending: [string, Set<string>][], index: number) => {
      if (index >= pending.length) {
        //this.props.handleUpdateMDMConfig(filteredRoot, newDM);
        if (this.props.actionDMERDiagram === 'BUILD_ENTITY'){
          const dm: { [key: string]: any } = {};
          dm[entity.name] = newDM;
          this.props.handleUploadMDMConfig(JSON.stringify(dm));
        }else{
          const dm: { [key: string]: any } = {};
          dm[entity.name] = newDM;
          this.props.handleUpdateMDMConfig(filteredRoot, dm, false);
        }
        return;
      }
      if (visited.has(index)) {
        handleMultipleParentPrompt(pending, index + 1 );
        return;
      }
      visited.add(index);

      const [tableName, columnNames] = pending[index];
      const fkTables = this.state.fkTableMap[tableName] || [];
      const pTables = fkTables.filter((t: string) => selectedTableNames.has(t));
      const fkInfoMap = this.state.fkInfoMap[tableName] || [];

      if (pTables.length <= 1) {
        const parent = pTables[0] || (tableName !== filteredRoot ? filteredRoot : null);
        processTable(tableName, columnNames, parent, null);
        handleMultipleParentPrompt(pending, index + 1);
      } else {
        processTable(tableName, columnNames, pTables[0], null);

        //find FK has value or not?
        for (let x = 1; x<pTables.length; x++){
          const tgtTbl = fkInfoMap.filter((f:any)=>{return f.referencedTable === pTables[x]})[0];
          if (tgtTbl){
            const col = (this.state.tableColumnMap[tableName] || []).filter((c:any)=>{return c.columnName === tgtTbl.column})[0];
            if (col && !isFieldUnused(col)){
              let _index = pending.findIndex(([_tableName, _]) => _tableName === pTables[x]);
              let [_tableName, _columnNames] = pending[_index];
              processTable(_tableName, _columnNames, pTables[0], tableName);
              visited.add(_index);
            }
          }
        }
        
        
        /*let _index = pending.findIndex(([_tableName, _]) => _tableName === pTables[1]);
        let [_tableName, _columnNames] = pending[_index];
        processTable(_tableName, _columnNames, pTables[0], tableName);
        visited.add(_index);*/
        handleMultipleParentPrompt(pending, index + 1 );

        /*
        confirmAlert({
          title: 'Multiple Parent Tables Detected',
          message: `Table '${tableName}' has multiple parents: ${pTables.join(', ')}.`,
          buttons: [
            {
              label: 'Combine Fields under First Parent',
              onClick: () => {
                processTable(tableName, columnNames, pTables[0], null);

                let _index = pending.findIndex(([tableName, _]) => tableName === pTables[1]);
                let [_tableName, _columnNames] = pending[_index];
                processTable(_tableName, _columnNames, pTables[0], tableName);

                handleMultipleParentPrompt(pending, index + 1, tableName );
              }
            },
            {
              label: 'Make Second Parent Grandchild',
              onClick: () => {
                // Treat second parent as the effective parent
                processTable(tableName, columnNames, pTables[0], overrideTableName);

                handleMultipleParentPrompt(pending, index + 1);
              }
            }
          ]
        });*/
      }
    };

    handleMultipleParentPrompt(pendingTables, 0);
  }

  
  onNodeClick = (_: any, node: any) => {
    
    const visited = this.recursivelyFindRelated(node.id);
    const elements = this.state.allElements.map((el) => {
      if ('source' in el && 'target' in el) {
        const isRelated = visited.has(el.source) && visited.has(el.target);
        return { ...el, style: { ...el.style, stroke: isRelated ? 'red' : '#999' } };
      } else if ('id' in el && visited.has(el.id)) {
        return { ...el, style: { ...el.style, border: '2px solid red' } };
      }
      return el;
    });
    this.rePositionElements(elements);
    //this.setState({ elements });
  };

  toggleShowEnityModal = ()=>{
    if (!this.props.selectedDMPrimaryTable){
      this.setState({showEnityModal: !this.state.showEnityModal});
    }else if (this.props.selectedDMPrimaryTable && !this.state.showEnityModal){
      this.buildSelectedDataModel(this.props.entity);
    }else{
      this.setState({showEnityModal: !this.state.showEnityModal});
    }
  }
  
  handleSaveShowEnityModal = (data: any) =>{
    this.buildSelectedDataModel(data);
    this.setState({showEnityModal: false});
    
  }
  
    handleTabSelect = (entityBuildType: string | null) => {
    if (entityBuildType) {
      this.setState({ entityBuildType });
    }
  };

  handleSaveImportEntity = ()=>{
    if (!this.state.entityImportEntityNm){return}
    const dm: { [key: string]: any } = {};
    const refDM: any[] = [];
    const be = this.props.data.entity.be[this.state.entityImportEntityNm];
    be['imported'] = true;
    dm[this.state.entityImportEntityNm] = be;
    if (this.props.actionDMERDiagram === 'BUILD_ENTITY'){
      const rawDM = convertToRawDm(dm);
      const srcSystems:any[] = [];
      refDM.push(be);
      cleanDm(refDM, srcSystems);
      
      const finalData ={
        "dm": rawDM,
        "refinedDM": refDM,
        "srcSystem": srcSystems,
        "relationships": [],
        "hierarchies": []
      }
      console.log(finalData);
      this.props.handleUploadMDMConfig(JSON.stringify(finalData));
    }else{
      this.props.handleUpdateMDMConfig(this.state.filteredElement, be, true);
    }
  }
  
  renderImportEnity = () =>{
    return (
      <div>
        <div className="d-flex justify-content-left">
          <Form.Group controlId="entitySelect" className="mb-3 custom-select-inline d-flex align-items-center" style={{width: '300px'}}>
            <Form.Label className="text-nowrap mr-2" style={{ marginRight:10, marginTop:8 }}>Entity</Form.Label>
            <Form.Control as="select" name="selectedDMEntityId" 
              value={this.state.entityImportEntityNm}
              onChange={(e) => this.setState({entityImportEntityNm: e.target.value})} >
                <option key={'select'} value={''}>--Select--</option>
                {Object.keys(this.props.data.entity.be).map((t:any) => (
                  <option key={t} value={t}>{this.props.data.entity.be[t].label}</option>
                ))}
            </Form.Control>
          </Form.Group>
          <div>
              <Button size="sm" style={{marginLeft:'13px' }}
              onClick={() => this.handleSaveImportEntity()}>Submit</Button>
          </div>
        </div>
      
          {this.state.entityImportEntityNm &&
          <div>
            <DataModelTreeNode dataModelData={this.props.data.entity.be[this.state.entityImportEntityNm]}  />
          </div>
          }
      </div>
    )
  }

  renderBuildDM = () => {
    
    const nodes = this.state.elements.filter((el): el is Node => 'id' in el && !('source' in el));
    const edges = this.state.elements.filter((el): el is Edge => 'source' in el);
    const parentMap = this.props.data && this.props.data.addBaseObject.filter((t:any)=>{return this.state.parentOptions.indexOf(t.tableName)>-1 && t.lookupIndicator==="false"})||[];
    parentMap.sort((a:any, b:any) => a.displayName.localeCompare(b.displayName));
    return (
      <div style={{ height: '20vh', width: '100%' }}>
        
        <div style={{ marginBottom: 10 }}>
          
          <div className="d-flex justify-content-between">
        
            <div className="d-flex justify-content-start">
              
                {!this.props.selectedDMPrimaryTable &&
                <Form.Group controlId="formAppNm" className="mb-3 custom-select d-flex" style={{width: '400px'}}>
                  <Form.Label className="text-nowrap mr-2" style={{ marginRight:10 }}>Primary Table</Form.Label>
                  <Form.Control as="select" name="primaryTable" 

                    value={this.state.filteredElement}
                    onChange={(e) => this.setFilteredElements(e.target.value)} >
                      <option value="" disabled>Select Parent Table</option>
                      <option value="ALL">All</option>
                      {parentMap.map((t:any) => (
                        <option key={t.tableName} value={t.tableName}>{t.displayName}</option>
                      ))}

                  </Form.Control>
                </Form.Group>
                }


              <span style={{ marginLeft: 20, marginRight:10 }}>Lookup Tables</span>
              <Switch
                checked={this.state.showLookupTables}
                onChange={this.toggleLookupTables}
                onColor="#196f3d"

                handleDiameter={20}
                height={24}
                width={70}
                checkedIcon={
                  <div style={{ paddingLeft: 10, color: 'white', fontSize: 10, display: 'flex', alignItems: 'center', height: '100%' }}>
                    SHOW
                  </div>
                }
                uncheckedIcon={
                  <div style={{ paddingLeft: 0, color: 'white', fontSize: 10, display: 'flex', alignItems: 'center', height: '100%' }}>
                    HIDE
                  </div>
                }
              />


              <span style={{ marginRight: 10, marginLeft:20 }}>Unused Tables</span>
              <Switch
                checked={this.state.showUnusedTables}
                onChange={this.toggleUnusedTables}
                onColor="#196f3d"
                handleDiameter={20}
                height={24}
                width={70}
                checkedIcon={
                  <div style={{ paddingLeft: 10, color: 'white', fontSize: 10, display: 'flex', alignItems: 'center', height: '100%' }}>
                    SHOW
                  </div>
                }
                uncheckedIcon={
                  <div style={{ paddingLeft: 0, color: 'white', fontSize: 10, display: 'flex', alignItems: 'center', height: '100%' }}>
                    HIDE
                  </div>
                }
              />

              <span style={{ marginRight: 10, marginLeft:20 }}>Unused Column</span>
              <Switch
                checked={this.state.showUnusedColumns}
                onChange={this.toggleUnusedColumns}
                onColor="#196f3d"
                handleDiameter={20}
                height={24}
                width={70}
                checkedIcon={
                  <div style={{ paddingLeft: 10, color: 'white', fontSize: 10, display: 'flex', alignItems: 'center', height: '100%' }}>
                    SHOW
                  </div>
                }
                uncheckedIcon={
                  <div style={{ paddingLeft: 0, color: 'white', fontSize: 10, display: 'flex', alignItems: 'center', height: '100%' }}>
                    HIDE
                  </div>
                }
              />

            </div>
            
            <div className="d-flex justify-content-end">
              <div>
                 <Button size="sm" style={{ marginRight: '5px', marginTop: '-8px', marginLeft:'-3px' }}
                  onClick={() => this.toggleShowEnityModal()}>Submit</Button>
              </div>
            </div>
            
          </div>
        </div>

        <div style={{ height: '80vh', width: '100%', overflow: 'auto', border: '1px solid #ccc' }}>
          <ReactFlowProvider>
            <ReactFlow
              nodes={nodes}
              edges={edges}
              fitView
              fitViewOptions={{ padding: 0.2 }}
            >
              <MiniMap />
              <Controls />
              <Background />
            </ReactFlow>
          </ReactFlowProvider>
        </div>
        
        <AddFieldModal show={this.state.showEnityModal} showNested={false} handleClose={this.toggleShowEnityModal} handleSave={this.handleSaveShowEnityModal}/>
        
      </div>
    );
  }

  render (){
    if (this.props.selectedDMPrimaryTable){
      return this.renderBuildDM()
    }
    return (
      <Tabs id="controlled-tab-dmbld"
            activeKey={this.state.entityBuildType}
            onSelect={this.handleTabSelect}
            variant="pills"
             className="modern-pill-tabs mb-3"
          >
            <Tab eventKey="entityImport" title="Import Entity">
              <div className="tab-content component" >
                {this.renderImportEnity()}
              </div>
            </Tab>
             <Tab eventKey="entityBuild component" title="Build Entity">
              <div className="tab-content">
                {this.renderBuildDM()}
              </div>
            </Tab>
        </Tabs>
    )
  }
}

export default DMERDiagram;
